import { useCurrentUserContext } from '@/contexts/CurrentUserContext';
import {
  OrganizationType,
  SubscriptionPlan,
  SubscriptionSource,
  UserSubscriptionStatus,
  UserTier,
} from '@/types/gql.generated';

// Subscription state lives on the org a subscription funds; the user's own
// subscription is the one funding their PERSONAL org. Additional (e.g. addon
// family) org subscriptions surface on their own orgs in `organizations`.
export const useSubscription = () => {
  const { currentUser } = useCurrentUserContext();
  const { tier, organizations } = currentUser ?? {};

  const personalOrg = organizations?.find(
    (org) => org.type === OrganizationType.Personal
  );
  const subscriptionStatus = personalOrg?.subscriptionStatus;
  const subscriptionPlan = personalOrg?.subscriptionPlan;
  const subscriptionSource = personalOrg?.subscriptionSource;
  const subscriptionCurrentPeriodEnd =
    personalOrg?.subscriptionCurrentPeriodEnd;

  const isSubscriptionActive =
    subscriptionStatus === UserSubscriptionStatus.Active &&
    !!subscriptionCurrentPeriodEnd &&
    new Date(subscriptionCurrentPeriodEnd) > new Date();

  return {
    tier,
    isProTier: tier === UserTier.Pro,
    isFreeTier: tier === UserTier.Free,
    subscriptionStatus,
    subscriptionPlan,
    isFamilyPlan: subscriptionPlan === SubscriptionPlan.Family,
    subscriptionSource,
    // Manual (offline/check) grants entitle the user like a Stripe sub, but have
    // no Stripe customer behind them — self-service billing actions must be
    // swapped for a contact-support path.
    isManualSubscription: subscriptionSource === SubscriptionSource.Manual,
    subscriptionCurrentPeriodEnd,
    isSubscriptionActive,
  };
};
